import { render, staticRenderFns } from "./JobTemplates.vue?vue&type=template&id=13972fd9&scoped=true&"
import script from "./JobTemplates.vue?vue&type=script&lang=js&"
export * from "./JobTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13972fd9",
  null
  
)

export default component.exports